import { defineMessages } from 'react-intl';

export const FormItem = defineMessages({
  requiredField: {
    id: 'app.FormItem.requiredField',
    defaultMessage: 'Toto pole je povinné!',
  },
  pulseRate: {
    id: 'app.FormItem.pulseRate',
  },
});
